<template>
  <div class="container top-level-div">
    <!-- <h2>Stripe Connect Confirmation</h2>
    <hr>
    <p>{{ code }}</p>
    <p>{{ state }}</p>
    <hr>
    <p>{{ stripeResponse }}</p>
    <hr>
    <button class="mylisting-button dark-button" @click="testAPI()">Test API</button> -->
    <h4 v-if="stripeResponse.message='Stripe connection successfullly completed!'">Your account has been successfully connected with Stripe.</h4>
    <h4 v-if="failedToConnect">There was a problem connecting your account with Stripe, please try again or contact Enginehire.</h4>
    <div style="padding-top: 25px;">
      <router-link :to="{ name: 'Agent Dashboard' }" class="mylisting-button dark-button">Return to Dashboard</router-link>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

// https://www.npmjs.com/package/vue-loading-overlay
import Vue from 'vue';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
Vue.use(Loading);

export default {
  data() {
    return {
      code: '',
      state: '',
      stripeApiKey: 'sk_test_vfHJkSvCd2CPAOv5i6fzdLaU00oWoTNDmA',
      stripeResponse: {},

      failedToConnect: false,
    }
  },
  created() {
    // https://stackoverflow.com/questions/42309986/vuejs-get-url-query
    this.code = this.$route.query.code
    this.state = this.$route.query.state

    // https://www.npmjs.com/package/vue-loading-overlay
    let loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      // container: this.$refs.formContainer,
      // canCancel: true,
      canCancel: false,
      // onCancel: this.onCancel,
    });
    // simulate AJAX
    setTimeout(() => {
      loader.hide()
      if (this.stripeResponse.message != 'Stripe connection successfullly completed!') {
        this.failedToConnect = true
      }

    },2500)

    this.completeConnection()
  },
  methods: {
    completeConnection() {
      // axios.post('https://connect.stripe.com/oauth/token', {

      // })

      // // Set your secret key: remember to switch to your live secret key in production
      // // See your keys here: https://dashboard.stripe.com/account/apikeys
      // const stripe = require('stripe')('sk_test_vfHJkSvCd2CPAOv5i6fzdLaU00oWoTNDmA');

      // stripe.oauth.token({
      //   grant_type: 'authorization_code',
      //   // code: 'ac_123456789',
      //   code: this.code,
      // }).then(function(response) {
      //   // asynchronously called
      //   // this.stripeResponse = response
      //   console.log('Code Posted')
      //   console.log(response)
      //   var connected_account_id = response.stripe_user_id;
      // });

      // axios.post('/complete-stripe-connection-test/', {
      axios.post('/complete-stripe-connection/', {
        authorization_code: this.code
      })
        .then(res => {
          console.log(res)
          this.stripeResponse = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    // testAPI() {
    //   // axios.post('/complete-stripe-connection/', {
    //   axios.post('/complete-stripe-connection-test/', {
    //     authorization_code: 'sjhgfj'
    //   })
    //     .then(res => {
    //       console.log(res)
    //       this.stripeResponse = res
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/StripeConnectConfirmation.vue